import React from 'react';
import Page from '../components/Page';
import axios from 'axios';
import StorageService from '../services/StorageService';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Label,
  Row,
  Table,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  FormText
} from 'reactstrap';
import { MdDone, MdClear, MdCreate } from 'react-icons/md';
import OrganisationForm, { STATE_ADD } from '../components/OrganisationForm';
import FeatureForm from '../components/FeatureForm';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import { Redirect } from 'react-router';
import companyImage from '../assets/img/users/placeholder.jpg';
import Avatar from '../components/Avatar';
import Switch from "react-switch";

class CompanyPage extends React.Component {
  _isMounted = true;
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      confirmModal: false,
      organisationList: [],
      selectedCompanyId: '',
      selectedData: '',
      isEdit: false,
      redirect: false,
      featureModal: false,
      show_has_store: false,
      allList: []
    };
  }

  toggle = (action, id) => () => {
    return this.setState({
      modal: !this.state.modal,
      isEdit:
        id != undefined || (id != null && action == 'EDIT') ? true : false,
      selectedCompanyId:
        id != undefined || (id != null && action == 'EDIT') ? id : '',
    });
  };

  toggleConfirmModal = (name, id) => () => {
    return this.setState({
      confirmModal: !this.state.confirmModal,
      selectedData: name,
      selectedCompanyId: id,
    });
  };

  toggleFeatureModal = (name, id) => () => {
    return this.setState({
      featureModal: !this.state.featureModal,
      selectedData: name,
      selectedCompanyId: id,
    });
  };

  closeFeatureModal = (title, message, level) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    });

    this.setState({
      featureModal: false,
      selectedData: '',
      selectedCompanyId: '',
    });

    window.location.reload();
  };

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    });

    this.setState({
      modal: false,
    });

    if (reload) {
      window.location.reload();
    } else {
      this.getOrganisationList();
    }
  };

  user = (id, name) => {
    this.props.history.push({
      pathname: '/company/' + id + '/user',
      state: name
    });
  };

  users = () => {
    this.props.history.push('/user');
  };

  delete = () => {
    const user = StorageService.getSession('user_info');
    const selected_org = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_API_URL;
    const data = {
      session_key: user.session_key,
      CompanyID: this.state.selectedCompanyId,
    };
    axios
      .post(url + ':3000/v1/company/delete', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          });
          return;
        }
        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Company deleted successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        });
        this.setState({ confirmModal: false });
        window.location.reload();
        //this.getOrganisationList();
        // if (selected_org.CompanyID === this.state.selectedCompanyId) {
        //   StorageService.clearSession('selected_org');
        //   window.location.reload();
        // } else {
        //   this.getOrganisationList();
        // }
      })
      .catch(error => {
        alert(error);
      });
  };

  getOrganisationList = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;
    const selected_org = StorageService.getSession('selected_org');

    const data = {
      session_key: user.session_key,
    };

    axios
      .post(url + ':3000/v1/company/getSystemCompany', data)
      .then(response => {
        const result = response.data;

        if (result.error == 'true' && result.message != 'Success') {
          alert(result.message);
          return;
        }
        if(this._isMounted) {
        this.setState({ allList:result.data,  organisationList: result.data });
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  toggleHasStoreRow = (e) => {
    this.setState({ show_has_store: !this.state.show_has_store}, () => this.custData());
  };

  custData() {
    const { allList, show_has_store } = this.state;
    let display_list = [];
    if(show_has_store) {
      display_list = allList.filter(el => el.Has_Store > 0);
    } else {
      display_list = allList;
    }

    this.setState({ organisationList: display_list });
  }

  componentDidMount() {
    const user = StorageService.getSession('user_info');
    const org = StorageService.getSession('selected_org');

    if (org.Features.length > 0) {
      let idx = org.Features.findIndex(el => el.Feature === 'Configuration');
      if (idx < 0) {
        this.setState({
          redirect: true,
        });
      }
    }

    if (user.superUser) {
      this.getOrganisationList();
    } else {
      this.setState({
        redirect: true,
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const selected_org = StorageService.getSession('selected_org');
    return (
      <Page
        className="CompanyPage"
        title="All Company"
        breadcrumbs={[{ name: 'All Company', active: true }]}
      >
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card>
              <CardBody>
                <div className="d-flex mb-4 justify-content-end">
                  {/* <div className="d-flex align-items-center">
                    <span style={{fontSize: '0.85rem', fontWeight: '500'}}>With Store Listing</span>&nbsp;&nbsp;
                    <Switch uncheckedIcon={false} checkedIcon={false} offColor="#E74C3C" onChange={this.toggleHasStoreRow} checked={this.state.show_has_store} />
                    &nbsp;&nbsp;({this.state.organisationList.length})
                  </div> */}
                  <Button
                    className="theme-button theme-button-primary"
                    onClick={this.toggle('ADD', null)}
                  >
                    Create
                  </Button>
                </div>
                <Table responsive hover className="ps-table tb-col-5">
                  <thead>
                    <tr>
                      <th style={{minWidth: '250px'}}>Name</th>
                      <th>Contact</th>
                      <th>Address</th>
                      {/* <th>Store Listing</th> */}
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.organisationList.length < 1 && (
                      <tr>
                        <td colSpan="5">
                          <div className="ps-empty-data">
                            <div className="empty-content">
                              <MdCreate />
                              <h4>No data to show</h4>
                              <span>
                                Click the 'Create' button to add new company
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}

                    {this.state.organisationList.length > 0 &&
                      this.state.organisationList.map((item, index) => {
                        return (
                          <tr
                            key={index}
                            className={
                              selected_org.CompanyID === item.CompanyID
                                ? 'active-user'
                                : ''
                            }
                          >
                            <td>
                              <Avatar
                                style={{
                                  width: '28px',
                                  height: '28px',
                                  marginRight: '8px',
                                }}
                                src={
                                  item.CompanyLogo === null ||
                                  item.CompanyLogo === ''
                                    ? companyImage
                                    : item.CompanyLogo
                                }
                              />{' '}
                              {item.CompanyName}
                            </td>
                            <td>{item.CompanyContact}</td>
                            <td>{item.CompanyAddress}</td>
                            {/* <td><span style={{ color: item.Has_Store > 0 ? 'green' : 'red'}}>{item.Has_Store > 0 ? 'Yes' : 'No'}</span></td> */}
                            <td>
                              <div className="ps-action-button">
                                <Button
                                  className="theme-button theme-button-secondary"
                                  onClick={this.toggle('EDIT', item.CompanyID)}
                                >
                                  Edit
                                </Button>
                                <Button
                                  className="theme-button theme-button-primary"
                                  onClick={() => this.user(item.CompanyID, item.CompanyName)}
                                >
                                  User
                                </Button>
                                <Button
                                  className="theme-button theme-button-dark"
                                  onClick={this.toggleFeatureModal(
                                    item.CompanyName,
                                    item.CompanyID,
                                  )}
                                >
                                  Feature
                                </Button>
                                {item.IsDefault == 0 && (
                                  <Button
                                    className="theme-button theme-button-primary-light"
                                    onClick={this.toggleConfirmModal(
                                      item.CompanyName,
                                      item.CompanyID,
                                    )}
                                  >
                                    Delete
                                  </Button>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle()}
          className={this.props.className}
          centered
        >
          <OrganisationForm
            history={this.props.history}
            onToggleModal={this.toggle}
            closeModal={this.closeModal}
            data={this.state}
          />
        </Modal>

        <Modal
          isOpen={this.state.featureModal}
          toggle={this.toggleFeatureModal()}
          className={this.props.className}
          centered
        >
          <FeatureForm
            history={this.props.history}
            onToggleModal={this.toggleFeatureModal}
            closeModal={this.closeFeatureModal}
            data={this.state}
          />
        </Modal>

        <Modal
          isOpen={this.state.confirmModal}
          toggle={this.toggleConfirmModal()}
          className={this.props.className}
          centered
          style={{ fontSize: '0.85rem' }}
        >
          <ModalHeader toggle={this.toggleConfirmModal()}>
            Delete Company
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>
                  Are you sure you want to delete {this.state.selectedData} ?
                </p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              className="theme-button theme-button-secondary"
              onClick={this.toggleConfirmModal()}
            >
              Discard
            </Button>
            <Button
              className="theme-button theme-button-primary"
              onClick={() => this.delete()}
            >
              Confirm
            </Button>{' '}
          </ModalFooter>
        </Modal>
      </Page>
    );
  }
}
export default CompanyPage;
